<template>
  <!-- deviceDetection 设备监测-->
  <div class="energy-flow">
    <div class="con">
      <div class="tree-left">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <div class="btns">
          <el-button type="primary" size="mini" @click="popupFn('add')">新增</el-button>
          <el-button type="primary" size="mini" @click="popupFn('eait')" :disabled="!unitItem.id">修改</el-button>
          <el-button type="danger" size="mini" @click="delFun" :disabled="!unitItem.id" class="del-btn">删除</el-button>
        </div>
        <div class="scroll" style="width:100%;height:93%">
          <el-scrollbar style="height:95%;width: 100%;">
            <el-tree :data="leftData" ref="leftTree" @node-click="leftTreeClick" highlight-current
              :expand-on-click-node="true" node-key="id" :filter-node-method="filterNode"
              :default-expanded-keys="defaultExpanded" :current-node-key='defaultDevice'>
              <span class="custom-tree-node" slot-scope="{node,data}" style="display: flex;align-items: center;">
                <img src="../../../public/static/image/elTree/group.png" style="margin-right: 2px;" />
                <span style="padding-left: 5px;"> {{data.deviceClassificationName}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>

      </div>
      <div class="content">
        <div class="tag_box">
          <el-tag size="mini" v-if="tag_flag" @click="tag_flag = !tag_flag">切换</el-tag>
          <el-tag type="success" size="mini" v-else @click="tag_flag = !tag_flag">切换</el-tag>
        </div>
        <div style="display: flex;">
          <div class="mytable" style="margin-top: 0;">
            <el-table v-if="tag_flag" ref="multipleTable" :data="tableData" stripe tooltip-effect="dark"
              style="width: 100%" :max-height="heights-60" border :row-style="{height: '0'}"
              :cell-style="{padding: '0'}" :header-row-style="{padding: '0'}">
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>

              <el-table-column width="55" align="center" label="序号">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="设备名称">
              </el-table-column>
              <el-table-column label="设备状态" width="100" align="center">
                <template slot-scope="scope"> <el-tag v-if="scope.row.deviceState">正常</el-tag><el-tag v-else
                    type="danger">异常</el-tag></template>
              </el-table-column>
              <el-table-column label="设备号" width="180" align="center">
                <template slot-scope="scope">{{ scope.row.virtualDeviceNo }}</template>
              </el-table-column>
              <el-table-column prop="picture" label="设备图片" width="94" align="center">
                <template #default="{row}">
                  <el-image style="width: 50px; height: 50px" :src="row.picture" :preview-src-list="[row.picture]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="picture" label="设备各项数据" width="194" align="center">
                <template #default="{row}">
                  <el-popover trigger="hover" placement="top">
                    <el-table :data="row.deviceVariousDataVOS" :max-height="300" border :row-style="{height: '0'}"
                      :cell-style="{padding: '0'}" :header-row-style="{padding: '0'}">
                      <el-table-column width="55" align="center" label="序号">
                        <template slot-scope="scope">
                          <span>{{ scope.$index + 1 }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="energyTypeName" label="能源类型名称" width="180">
                      </el-table-column>
                      <el-table-column prop="numericalNum" label="能源类型数据" width="180">
                      </el-table-column>
                    </el-table>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">各项数据</el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <div class="card_box" v-else :style="{height: heights-60 +'px'}">
              <el-card class="box-card" v-for="(e,i) in tableData" :key="i">
                <div slot="header" class="clearfix">
                  <div class="left">
                    <el-image style="width: 60px; height: 60px" :src="e.picture" :preview-src-list="[e.picture]">
                    </el-image>
                  </div>
                  <div class="right">
                    <p>{{e.name}}</p>
                    <p>状态：{{e.deviceState?'正常':'异常'}} </p>
                    <p>设备号：{{e.virtualDeviceNo}}</p>
                  </div>
                </div>
                <div v-for="(o,ii) in e.deviceVariousDataVOS" :key="ii" class="text item">
                  <div class="p">
                    <div class="l">{{o.energyTypeName}}</div>
                    <div class="r">{{o.numericalNum}}</div>
                  </div>
                </div>
              </el-card>
            </div>
            <div class="paging" style="  margin-top: 10px; ">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" background :page-sizes="[10, 20, 30, 40, 50]" :page-size="currentSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增修改 -->
    <el-dialog v-dialogDrag :title="dialogStatus" :close-on-click-modal='false' :visible.sync="dialogVisible"
      width="22%" center class="unify-dialog">
      <div style="display: flex;">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 95%;height: 150px;padding-top: 10px;"
          label-width="40px">
          <el-form-item label="名称：:" prop="deviceClassificationName">
            <el-input v-model="temp.deviceClassificationName" style=""></el-input>
          </el-form-item>
          <el-form-item label="设备分类：" prop="deviceTypeId">
            <el-select v-model="temp.deviceTypeId" placeholder="请选择类型">
              <el-option v-for="(e,i) in selectData" :key="i" :label="e.deviceTypeName" :value="e.id" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="determine_Fn(dialogStatus)">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>

  import {getReadDeviceTree} from "../../api/abbNewApi";
  import Pagination from "@/components/module/Pagination"; // 分页
  import {findModelTree,saveDissipation,updateDissipation,deleteDissipation,dissipaFinDevice,dissipationSave,dissipationRemove} from "../../api/dissipation";
  // import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import request from "@/api/http.js";
  export default {
    components: {Pagination},
    data () {
      return {
        tag_flag: false,
        currentSize: 10,
        currentPage: 1,
        heights: document.getElementById('app').clientHeight-140,
        loading: false,
        dialogStatus: "新增",//弹窗类型
        radio: "能流分析",//单选框
        selectData: [],
        leftData: [],//左边树形结构数据 
        defaultProps: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
        filterText: '',
        filterTextRight: "",
        tableData: [],
        multipleSelection: [],
        rules: {
          code: [
            {required: true,message: '请输入编号',trigger: 'blur'}
          ],
          deviceClassificationName: [
            {required: true,message: '请输入名称',trigger: 'blur'}
          ],
          modelType: [
            {required: true,message: '请输入类型',trigger: 'blur'}
          ],
        },
        temp: {
          modelName: "",
          modelType: "",
        },
        dialogVisible: false,
        unitItem: {},
        tag: 1,//判断点击的是单位/能流图/节点
        nodeItem: [],//节点
        checkedNodes: [],
        halfCheckedNodes: null,
        nowNode: "",
        defaultExpanded: [],
        defaultDevice: "",
        firstItem: "",
      }
    },
    watch: {
      'temp.deviceTypeId': function(val) {
        if(val==''||!val) {
          this.temp.deviceTypeId=''
          return
        }
        // deviceTypeName
        this.selectData.map(v => {
          if(val==v.id) {
            this.temp.deviceTypeName=v.deviceTypeName||this.temp.deviceClassificationName;
          }
        })

      },
      filterText (val) {
        this.$refs.leftTree.filter(val);
      },
      filterTextRight (val) {
        this.$refs.tree.filter(val);
      },
      unitId () {
        this.findUnitInfoFun()
      }

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
    mounted () {
      var id=this.unitId.id;
      request({url: "/deviceClassification/getDeviceTypeAll",method: "get"}).then(res => {
        if(res.code==200) {
          this.selectData=res.data;
        }
      })
      this.findUnitInfoFun()
      var num=0

    },
    beforeDestroy () {
      this.nodeItem=[]
    },
    methods: {
      //左边树形结构筛选
      filterNode (value,data) {

        if(!value) return true;
        return data.deviceClassificationName.indexOf(value)!==-1;
      },
      //右边树形结构筛选
      filterNodeRight (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      //表格全选反选
      toggleSelection (rows) {
        if(rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange (val) {
        this.multipleSelection=val;
      },
      //左边树形结构数据
      findUnitInfoFun () {
        var params={
          unitId: this.unitId.id
        }
        request({url: "/deviceClassification/getAllByUnitId",method: "get",params}).then(res => {
          console.log(res,'设备分类->根据单位Id获取设备分类');
          var d=res.data[0];
          if(res.code==200) {
            this.leftData=res.data;
            if(this.leftData.length) {
              this.getDeviceList({id: this.leftData[0].id})
            }

          }
        })
      },
      //左边数据结构点击
      leftTreeClick (item) {
        this.unitItem=item;
        this.getDeviceList(item)
      },
      //获取能流图列表
      getDeviceList (v) {
        var params={
          id: v.id,
          pageIndex: this.currentPage,
          pageSize: this.currentSize,
        }
        request({url: "/deviceClassification/getDevicesByDeviceClassificationId",method: "get",params}).then(res => {
          if(res.code==200) {
            this.tableData=res.data.content;
            this.total=res.data.totalElements;
          }
        })
      },
      //弹窗
      popupFn (type) {
        var params={
          unitId: this.unitId.id
        }

        this.dialogVisible=true
        if(type=='add') {
          this.dialogStatus="新增"
          this.temp={
            deviceClassificationName: '',
            deviceTypeId: '',
            unitId: this.unitId.id
          }

        } else if(type=='eait') {
          this.dialogStatus="修改"
          this.temp=Object.assign({},this.unitItem)

        }
      },
      //添加成功提示
      addSuccess (type) {
        if(type=='新增') {
          this.$message({type: 'success',message: '添加成功!'});
        } else {
          this.$message({type: 'success',message: '修改成功!'});
        }
        this.findUnitInfoFun()
        this.temp.modelName=""
        this.temp.modelType=""
        this.dialogVisible=false
      },
      //新增修改
      determine_Fn (type) {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            if(type=='新增') {
              //新增模型 
              var data=this.temp;
              request({url: "/deviceClassification/save",method: "post",data}).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('添加失败')
                }
              })
            } else if(type=='修改') {
              var data=this.temp;
              data.uid=data.id;
              request({url: "/deviceClassification/save",method: "post",data}).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('修改失败')
                }
              })
              // updateDissipation(this.temp).then(res => {
              //   if(res.code==200) {
              //     this.addSuccess(type)
              //   } else {
              //     res.message? this.$message.error(res.message):this.$message.error('修改失败')
              //   }
              // })
            }

          } else {
            return false;
          }
        });


      },
      //删除操作
      delFun () {
        if(this.unitItem.length==0) {
          this.$message({type: 'warning',message: '请选择节点'});
          return
        }

        this.$confirm(`是否删除该 ${this.unitItem.deviceClassificationName}?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params={
            id: this.unitItem.id
          }
          request({url: "/deviceClassification/delete",method: "delete",params}).then(res => {
            if(res.code==200) {
              this.findUnitInfoFun()
              this.$message({type: 'success',message: `删除 ${this.unitItem.deviceClassificationName} 成功!`});
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      //移除能流图节点的关联设备
      device_Del () {
        // console.log("this.multipleSelection",this.multipleSelection);
        if(this.multipleSelection.length==0) {
          this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
          return
        }
        var ids=""
        this.multipleSelection.forEach(item => ids+=','+item.virtualDeviceNo)


        var params={
          "noes": ids.slice(1),
          "id": this.unitItem.id
        }

        request({url: "/deviceClassification/deleteDeviceByClassification",method: "DELETE",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.$message({type: 'success',message: '移除成功!'});
            this.findUnitInfoFun();
            this.getDeviceList({id: this.unitItem.id})
          } else {
            this.$message({type: 'error',message: `移除失败,${res.message}`});
          }
        })
        // dissipationRemove(d).then(res => {
        //   if(res.code==200) {
        //     this.$message({type: 'success',message: '移除成功!'});
        //     this.getDeviceList({id: this.unitItem.id})
        //   } else {
        //     this.$message({type: 'error',message: `移除失败,${res.message}`});
        //   }
        // })

      },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        var mycheckedNodes=SelectedObj.checkedNodes
        this.checkedNodes=mycheckedNodes.filter(item => item.Content.Category=='Device')
      },
      //添加能流图节点的关联设备
      device_Add () {
        //  console.log(this.nodeItem);
        if(!this.unitItem.id) {
          this.$message({type: 'warning',message: '请选择节点!'});
          return
        }
        if(this.checkedNodes.length==0) {
          this.$message({type: 'warning',message: '请勾选需要添加的设备!'});
          return
        }
        var devices=[]
        this.checkedNodes.forEach(item => {
          devices.push(item.Content.Id)
        })
        var params={
          "noes": devices.join(','),
          "id": this.unitItem.id
        }

        request({url: "/deviceClassification/saveDeviceByClassification",method: "post",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.checkedNodes=[];
            this.$refs.tree.setCheckedKeys([]);
            this.$message({type: 'success',message: '添加成功!'});
            this.findUnitInfoFun();
            this.getDeviceList({id: this.unitItem.id})
          } else {
            this.$message({type: 'error',message: `添加失败! ${res.message}`});
          }
        })
        // dissipationSave(d).then(res => {
        //   //  console.log("res添加设备",res);
        //   if(res.code==200) {
        //     this.$message({type: 'success',message: '添加成功!'});
        //     this.checkedNodes=[]
        //     this.$refs.tree.setCheckedKeys([]); 
        //   } else {
        //     this.$message({type: 'error',message: `添加失败! ${res.message}`});
        //   }
        // })



        // console.log("checkedNodes",this.checkedNodes);
        // console.log("12131",this.nodeItem);
      },

      //分页功能
      newgetNowPageDataList () {
        this.getDeviceList({id: this.unitItem.id})

      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }
    },
  }
</script>

<style lang='scss' scoped>
  .p {
    display: flex;
    justify-content: space-between;
  }

  .clearfix {
    display: flex;
  }

  .clearfix>.left {
    margin-right: 20px;
  }

  .clearfix>.right {
    flex: 1;
    font-size: 20px;
    font-weight: bold;
  }

  .clearfix>.right p {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .card_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

  }

  .card_box .box-card {
    width: calc(20% - 10px);
    box-sizing: border-box;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .card_box .box-card:nth-child(n*5) {
    margin-right: 0;
  }

  .tag_box {
    margin: 5px;
    margin-left: 20px;
  }

  .tag_box>span {
    cursor: pointer;
  }

  .energy-flow {
    width: 100%;
    padding: 8px;
  }

  .con {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;

    .con-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin-left: 10px;
      margin-top: 20px;

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 20px 12px 12px 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .content {
      // flex-grow: 1;
      width: calc(100% - 3rem);
      background-color: #fff;
      border-right: 1px solid #e6e6e6;

      .content-title {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 16px;
        color: #999;
      }

      .mytable {
        width: 100%;
        box-sizing: border-box;
        margin: 20px 20px 0px 20px;
      }

      .conten-btns {
        margin-top: 200px;

        // button {
        //    margin-bottom: 20px;
        // }
        div {
          width: 0.88rem;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          border-radius: 2px;
          background-color: #409EFF;
          color: #fff;
          margin-bottom: 40px;
          cursor: pointer;

          img {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.1rem;
          }
        }

      }
    }

    .tree-right {
      width: 3rem;
      height: 100%;
      background-color: #fff;
      padding: 20px 12px 12px 20px;
      box-sizing: border-box;
    }
  }
</style>